<template>
	<v-row flat color="transparent">
		<v-col v-if="survey">
			<v-text-field v-model="survey.title" label="Survey Title"></v-text-field>
			<v-row>
				<v-col>
					<v-card>
					<v-system-bar height="30" color="lightGrey">
						<v-spacer></v-spacer>
						<v-btn icon small class="mr-1" @click="json_dialog = true"><v-icon small>mdi-code-braces</v-icon></v-btn>
						<v-btn icon small class="mr-1" @click="preview_dialog = true"><v-icon small>mdi-magnify</v-icon></v-btn>
					</v-system-bar>					
					<SurveyBuilder 
					:id="id"
					></SurveyBuilder>
					</v-card>
				</v-col>
			</v-row>
			<v-row>
				<v-col>					
					<p class="text-right">
						<SaveSavingSaved :status="status" @save="save"></SaveSavingSaved>
					</p>
				</v-col>
			</v-row>


			<v-dialog v-model="preview_dialog" full-screen>
				<v-card>			
				<v-card-text>
					
					<DialogTitle title="Preview" @close="preview_dialog = false" ></DialogTitle>
					<CnRenderSurvey :surveyContent="survey"></CnRenderSurvey>
				</v-card-text>
				</v-card>
			</v-dialog>
			<v-dialog v-model="json_dialog" full-screen>
				<v-card>
					<DialogTitle title="JSON Editor" @close="json_dialog = false" ></DialogTitle>
					<v-card-text>				
						<EditSurveyJson :survey="survey"></EditSurveyJson>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-col>
	</v-row>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DialogTitle from "@/components/elements/DialogTitle"
	import SaveSavingSaved from "@/components/elements/SaveSavingSaved"
	import CnRenderSurvey from "@/components/survey/CnRenderSurvey"
	import EditSurveyJson from "@/components/survey/survey-builder/EditSurveyJson"
	import SurveyBuilder from "@/components/survey/survey-builder/SurveyBuilder"
	export default {
		name: "EditSurvey", 
		props: {
			id: {type: String }
		},
		data: () => {
			return {
				status: null,
				preview_dialog: false,
				json_dialog: false
			}
		},
		components: {
			DialogTitle,
			SaveSavingSaved,
			CnRenderSurvey,
			SurveyBuilder,
			EditSurveyJson
		},
		computed: {
			...Vuex.mapState({
				surveys: state => state.surveys || []
			}),
			survey() {
				var id = this.id;
				return this.surveys.find(s => s.id == id)
			}
		},
		watch: {
			survey: {
				deep: true, 
				handler(){
					this.status = "unsaved";
				}
			}
		},
		methods: {
			save(){
				const self = this;
				self.status = "saving"
				self.$store.dispatch("surveys/save", self.survey ).then( () => {
					if( self.$route.path == "/new-survey" ){
						this.$store.dispatch("surveys/emptyNewSurvey", self.survey )
						self.$router.push("/surveys/"+ this.id )
					}
					self.status = "saved"
				})
			}
		},
		destroyed(){
		}

	}
</script>